import { render, staticRenderFns } from "./ClientPreference.vue?vue&type=template&id=a862b6b8&"
import script from "./ClientPreference.vue?vue&type=script&lang=js&"
export * from "./ClientPreference.vue?vue&type=script&lang=js&"
import style0 from "./ClientPreference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports